document.addEventListener('DOMContentLoaded', function () {

  const addToCartWrapper = document.querySelector('.purchase-details__buttons');

  if (addToCartWrapper && window.innerWidth < 481) {

    const productForm = document.querySelector('.shopify-product-form');
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        addToCartWrapper.classList.remove('purchase-details__buttons--sticky');
      } else {
        addToCartWrapper.classList.add('purchase-details__buttons--sticky');
      }
    }, observerOptions);

    observer.observe(productForm);
  }
});

/* =============================================
   Snell Golf — PDP buy box (Oct 2026)
   1. Hide variant pickers when every option has only one value
      (e.g. MTB Black LTD: Color = White only). The hidden select
      still submits the variant id.
   2. Show the selected variant's price inside the Add to Cart
      button on phones, so the sticky bar carries the price.
   ============================================= */
(function () {
  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (!format || format.indexOf('{{') === -1) return '$' + withCommas;
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas.split('.')[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  function initForm(wrapper) {
    if (wrapper.dataset.snellBuyBox) return;
    wrapper.dataset.snellBuyBox = '1';

    var product;
    try {
      product = JSON.parse(wrapper.getAttribute('data-product'));
    } catch (e) {
      return;
    }
    if (!product || !product.variants) return;

    // 1. One-choice variant pickers
    var options = product.options || [];
    var singleChoice = options.length > 0 && !(options.length === 1 && options[0] === 'Title');
    if (singleChoice) {
      for (var i = 0; i < options.length; i++) {
        var values = {};
        product.variants.forEach(function (v) { values[v['option' + (i + 1)]] = true; });
        if (Object.keys(values).length > 1) { singleChoice = false; break; }
      }
    }
    if (singleChoice) wrapper.classList.add('product_form--single-choice');

    // 2. Price inside the Add to Cart button (rendered by CSS from a data
    //    attribute, because the theme rewrites the button's text on load)
    var button = wrapper.querySelector('.add_to_cart');
    var idSelect = wrapper.querySelector('select[name="id"], input[name="id"]');
    if (!button || !idSelect) return;

    var moneyFormat = wrapper.getAttribute('data-money-format');

    function update() {
      var id = String(idSelect.value);
      var variant = product.variants.filter(function (v) { return String(v.id) === id; })[0];
      if (!variant || !variant.available) {
        button.removeAttribute('data-snell-price');
        return;
      }
      button.setAttribute('data-snell-price', formatMoney(variant.price, moneyFormat));
    }

    update();
    wrapper.addEventListener('change', function () { setTimeout(update, 50); });
    wrapper.addEventListener('click', function (e) {
      if (e.target.closest('.swatch, .swatch-element, label')) setTimeout(update, 50);
    });
  }

  function initAll() {
    document.querySelectorAll('.product_form[data-product-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
